import styled, { keyframes } from 'styled-components';
import { colors } from '../../utils/colors';

export const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const Container = styled.div`
  position: fixed;
  bottom: 0;
  top: 0;
  right: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  gap: 5px;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  background-color: ${colors.preto2};
`;

export const ContainerLoading = styled.div`
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
`;

export const ContainerRing = styled.div`
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 64px;
  height: 64px;
  margin: 8px;
  border: 8px solid ${colors.verde20};
  border-radius: 50%;
  animation: ${rotate} 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: ${colors.verde20} transparent transparent transparent;
  &:nth-child(1) {
    animation-delay: -0.45s;
  }
  &:nth-child(2) {
    animation-delay: -0.3s;
  }
  &:nth-child(3) {
    animation-delay: -0.15s;
  }
`;

export const TextLabel = styled.div`
  font-size: 1.15rem;
  color: ${colors.branco};
`;

export const Button = styled.button`
  cursor: pointer;
  background: ${colors.branco};
  color: ${colors.verde20};
  font-size: 1rem;
  margin: 1em;
  padding: 0.25em 1em;
  border: 2px solid green;
  border-radius: 2px;
  transition: all 250ms ease-in-out;
  &:hover {
    background: ${colors.verde20};
    color: ${colors.branco};
  }
`;
